"use strict";
import Api from "../../api/api";
function isAddDocumentToLoadEnabled(isConfirmAndSubmit, maybeLoadState, maybeCarrierInvoice) {
  const featureFlagEnabled = !!Api.Account.currentSettings().auditor_document_upload_enabled;
  return !!(isConfirmAndSubmit && featureFlagEnabled && maybeLoadState && maybeCarrierInvoice);
}
export { isAddDocumentToLoadEnabled };
